module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_berliner_sm-bcd323241b8976e34ea23ce440bab129.png";